<template>
  <div>
    <h4 class="title is-4">My Approvals</h4>
    <div class="level">
      <div class="level-left">
        <button class="button is-small" @click="refreshTable()">Refresh</button>
        &nbsp;
        <button
          v-if="this.checkedData.length > 0"
          :class="buttonSave"
          @click="bulkApprove()"
        >
          Approve Selected ({{ this.checkedData.length }})
        </button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination
      :tableData="poRequests.data"
      :bordered="true"
      :striped="true"
      :narrowed="true"
      :search="search"
      :hoverable="true"
      :mobileCards="true"
      :loading="isLoadingTable"
      :page="page"
      :perPage="perPage"
      :totalData="poRequests.totalData"
      @onPageChanged="page = $event"
      @onSearchChanged="search = $event"
      @onPerPageChanged="perPage = $event"
      @checkedRowsChanged="checkedData = $event"
      :checkable="true"
    >
      <template slot="row-content" slot-scope="{ item }">
        <b-table-column
          class="table-column-content-is-small"
          label="Request ID"
        >
          {{ item.row.poRequestId }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Client P.O. #"
        >
          {{ item.row.poNumber }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Agent">
          {{ item.row.user }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Client">
          {{ item.row.client }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Total cost"
        >
          {{ item.row.totalCost }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Selling">
          {{ item.row.selling }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Margin">
          {{ item.row.margin }}%
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Profit">
          {{ item.row.profit }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Sales Based"
        >
          <center>
            <b-tag
              size="is-small"
              style="font-size: 9px; background-color: #d770ad; color: white"
            >
              <span v-if="item.row.isAdaptive"> ADAPTIVE </span>
              <span v-else> ANSI </span>
            </b-tag>
          </center>
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Date submitted"
        >
          {{ item.row.dateCreated }}
        </b-table-column>
        <!-- <b-table-column
          style="center"
          class="table-column-content-is-small"
          label="Email notif."
          centered
        >
          <p class="has-text-success" v-if="item.row.isSent">
            <span class="icon">
              <i class="fas fa-check"></i>
            </span>
          </p>
          <p class="has-text-danger" v-else>
            <span class="icon">
              <i class="fas fa-times"></i>
            </span>
          </p>
        </b-table-column> -->
        <b-table-column
          style="center"
          class="table-column-content-is-small"
          label="Approve"
          centered
        >
          <span class="tag is-dark" v-if="item.row.isPending === true"
            >Pending</span
          >
          <span v-else>
            <span v-if="item.row.isApprove">
              <p class="has-text-success">
                <span class="icon">
                  <i class="fas fa-check"></i>
                </span>
              </p>
              <span style="font-size: 9px" v-if="item.row.approvedBy"
                ><strong>{{ item.row.approvedBy }}</strong></span
              >
            </span>
            <p class="has-text-danger" v-else>
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </p>
          </span>
        </b-table-column>
        <b-table-column
          style="center"
          class="table-column-content-is-small"
          label="Request for Edit"
          centered
        >
          <span v-if="item.row.isRequestForEdit === true"> Yes </span>
          <span v-else> No </span>
        </b-table-column>
        <b-table-column
          style="center"
          class="table-column-content-is-small"
          label="Final Approval"
          centered
        >
          <span v-if="item.row.isApprovedByFinalApprover === true">
            <p class="has-text-success">
              <span class="icon">
                <i class="fas fa-check"></i>
              </span>
            </p>
            <span style="font-size: 9px" v-if="item.row.finalApprover"
              ><strong>{{ item.row.finalApprover }}</strong></span
            >
          </span>
          <p
            class="has-text-danger"
            v-if="item.row.isApprovedByFinalApprover === false"
          >
            <span class="icon">
              <i class="fas fa-times"></i>
            </span>
          </p>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Deliver">
          <span v-if="item.row.deliveryStatusInt == 0">
            <b-tag
              size="is-small"
              style="font-size: 9px; background-color: #e08a1e; color: white"
            >
              <span class="icon"> <i class="fas fa-warehouse"></i></span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 1">
            <b-tag
              size="is-small"
              style="font-size: 9px; background-color: #22a7f0; color: white"
            >
              <span class="icon">
                <i class="fas fa-truck"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 2">
            <b-tag
              size="is-small"
              style="font-size: 9px; background-color: #59abe3; color: white"
            >
              <span class="icon">
                <i class="fas fa-list-ol"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 3">
            <b-tag
              size="is-small"
              style="font-size: 9px; background-color: #26c281; color: white"
            >
              <span class="icon">
                <i class="fas fa-check"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 4">
            <b-tag
              size="is-small"
              style="font-size: 9px; background-color: #c91f37; color: white"
            >
              <span class="icon">
                <i class="fas fa-ban"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
          <span v-if="item.row.deliveryStatusInt == 5">
            <b-tag
              size="is-small"
              style="font-size: 9px; background-color: #f9690e; color: white"
            >
              <span class="icon">
                <i class="fas fa-truck fa-flip-horizontal"></i>
              </span>
              {{ item.row.deliveryStatus }}
            </b-tag>
          </span>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button
            :class="buttonDownloadPoRequest"
            @click="downloadPdf(item.row.poRequestId, item.row.user)"
            title="Download PDF"
          >
            <span class="icon">
              <i class="far fa-file-pdf"></i>
            </span>
          </button>
          &nbsp;
          <button
            class="button is-small"
            @click="openHistoryLog(item.row.history)"
            title="View history log"
          >
            <i class="fas fa-history"></i>
          </button>
          &nbsp;
          <router-link
            class="button is-small is-warning"
            :to="{
              name: 'Edit PO Request',
              params: { poRequestId: item.row.poRequestId },
            }"
            >Edit</router-link
          >
          &nbsp;
          <button
            class="button is-small is-danger"
            @click="deletePoRequest(item.row.poRequestId)"
          >
            Delete
          </button>
        </b-table-column>
      </template>
    </table-pagination>
    <Delete />
    <HistoryLog />
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import TablePagination from "../TablePagination.vue";
import Delete from "./Delete.vue";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import HistoryLog from "./HistoryLog";

const appToast = new AppToast();
const appButton = new AppButton();

export default {
  components: {
    TablePagination,
    Delete,
    HistoryLog,
  },
  mounted() {
    this.default();
  },
  computed: {
    ...mapState("porequest", {
      poRequests: (state) => state.poRequests,
      isLoadingTable: (state) => state.isLoadingTable,
    }),
  },
  data: () => ({
    checkedData: [],
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: "",
    buttonDownloadPoRequest: appButton.isLoadingDefault(false),
    buttonSave: appButton.isLoadingSuccess(false),
  }),
  created() {
    const perPageFromRoute = this.$route.params.pageSize;
    const searchQueryFromRoute = this.$route.params.searchQuery;

    this.perPage = perPageFromRoute ? perPageFromRoute : 10;
    this.search = searchQueryFromRoute ? searchQueryFromRoute : "";
  },
  methods: {
    ...mapActions("porequest", [
      "getPaginatedPoRequestsForFinalApproval",
      "openHistoryLogModal",
      "openDeleteModal",
    ]),
    openHistoryLog(historyLog) {
      this.openHistoryLogModal({
        showHistoryLog: true,
        historyLog: historyLog,
      });
    },
    bulkApprove() {
      if (this.checkedData.length > 0) {
        this.buttonSave = appButton.isLoadingSuccess(true);
        let poRequestIds = [];
        this.checkedData.forEach((d) => {
          poRequestIds = [...poRequestIds, d.poRequestId];
        });

        axios
          .post(`api/porequests/bulk-final-approval`, poRequestIds)
          .then((response) => {
            appToast.success(response.data);
            this.buttonSave = appButton.isLoadingSuccess(false);
            this.refreshTable();
            this.checkedData = [];
          })
          .catch((error) => {
            console.log(error);
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      }
    },
    refreshTable() {
      this.default();
    },
    downloadPdf(poRequestId, agentName) {
      if (poRequestId) {
        this.buttonDownloadPoRequest = appButton.isLoadingDefault(true);
        axios
          .get(`downloadables/porequest?id=${poRequestId}`, {
            responseType: "blob",
          })
          .then((response) => {
            console.log(response.data);
            const windowUrl = window.URL || window.webkitURL;
            const url = windowUrl.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `P.O. request by - ${agentName} - ${poRequestId}.pdf`
            );
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.log(error);
          })
          .then(
            () =>
              (this.buttonDownloadPoRequest = appButton.isLoadingDefault(false))
          );
      }
    },
    default() {
      this.getPaginatedPoRequestsForFinalApproval({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
      });
    },
    deletePoRequest(id, companyName) {
      this.openDeleteModal({
        showDeleteModal: true,
        poRequest: {
          poRequestId: id,
        },
      });
    },
  },
  watch: {
    checkedData() {
      console.log(this.checkedData);
    },
    perPage(val) {
      this.$router.push({
        name: "List of PO Requests for Final Approval",
        params: {
          pageSize: !val ? 10 : val,
          searchQuery: !this.search ? null : this.search,
        },
      });

      this.getPaginatedPoRequestsForFinalApproval({
        page: this.page,
        pageSize: val,
        query: this.search,
      });
    },
    page(val) {
      this.getPaginatedPoRequestsForFinalApproval({
        page: val,
        pageSize: this.perPage,
        query: this.search,
      });
    },
    search(val) {
      this.$router.push({
        name: "List of PO Requests for Final Approval",
        params: {
          pageSize: this.perPage,
          searchQuery: !val ? null : val,
        },
      });

      this.getPaginatedPoRequestsForFinalApproval({
        page: this.page,
        pageSize: this.perPage,
        query: val,
      });
    },
  },
};
</script>
